<template>
  <div class="mb-2">
    <AppFilter :filters="filterConfig" :filter-submitting="filterSubmitting" @filter="handleFilter">
      <template #extra-actions>
        <b-button
          id="create-new-btn"
          variant="primary"
          class="create-new-btn"
          @click="createCostPrice"
        >
          <feather-icon icon="PlusIcon" size="15" />
          {{ $t('Create Unit Price') }}
        </b-button>
      </template>
    </AppFilter>
  </div>
</template>

<script>
import AppFilter from '@/components/AppFilter/AppFilter.vue';
import { helper } from '@core/mixins/helper';
import { BButton } from 'bootstrap-vue';
import useService from '@/auth/service/useService';

export default {
  name: 'CostPricesFilter',

  components: {
    AppFilter,
    BButton
  },

  mixins: [helper],

  props: {
    values: {
      type: Object,
      required: true
    },
    filterSubmitting: {
      type: Boolean,
      required: true,
      default: false
    }
  },

  data() {
    return {
      tradeDirectionOptions: [],
      tradeTypeOptions: [],
      serviceProviderOptions: [],
      packagingTypeOptions: [],
      packageTypeOptions: []
    };
  },

  computed: {
    filterConfig() {
      return [
        {
          id: 'transportDirection',
          label: this.$t('Transport Direction'),
          type: 'select',
          options: this.tradeDirectionOptions,
          placeholder: this.$t('Make a Choice')
        },
        {
          id: 'transportType',
          label: this.$t('Transport Type'),
          type: 'select',
          options: this.tradeTypeOptions,
          placeholder: this.$t('Make a Choice')
        },
        {
          id: 'providerId',
          label: this.$t('Service Provider'),
          type: 'select',
          options: this.serviceProviderOptions,
          childKeys: ['packageTypeValue'],
          placeholder: this.$t('Make a Choice')
        },
        {
          id: 'packageType',
          label: this.$t('Packaging Type'),
          type: 'select',
          options: this.packagingTypeOptions,
          childKeys: ['packageTypeValue'],
          placeholder: this.$t('Make a Choice')
        },
        {
          id: 'packageTypeValue',
          label: this.$t('Package Type'),
          type: 'select',
          asyncOptions: currFilters => this.getPackageTypes(currFilters),
          placeholder: this.$t('Make a Choice')
        },
        {
          id: 'activeAt',
          label: this.$t('Active At'),
          type: 'date',
          placeholder: this.$t('Make a Choice')
        },
        {
          id: 'activeUntil',
          label: this.$t('Active Until'),
          type: 'date',
          placeholder: this.$t('Make a Choice')
        }
      ];
    }
  },

  async created() {
    await this.loadFilterOptions();
  },

  methods: {
    async getPackageTypes(currFilters) {
      try {
        let packageTypes = [];
        if (currFilters.packageType === 1 || !currFilters.packageType) {
          packageTypes = await useService.constantService.getConsignmentPackageType().then(res => {
            return res.data.map(i => ({
              label: i.info,
              value: i.value
            }));
          });
        } else if (currFilters.packageType === 2 && currFilters.providerId) {
          packageTypes = await useService.providerService
            .getProviderPackageTypes(currFilters.providerId)
            .then(res => {
              return (res?.data || []).map(i => ({
                label: i.description,
                value: i.packagingType
              }));
            });
        } else {
          return [];
        }

        return packageTypes;
      } catch (error) {
        return [];
      }
    },

    handleFilter(filters) {
      this.$emit('filter', {
        ...filters,
        activeAt: filters.activeAt
          ? this.$dayjs(filters.activeAt).format('YYYY-MM-DD 00:00:00')
          : '',
        activeUntil: filters.activeUntil
          ? this.$dayjs(filters.activeUntil).format('YYYY-MM-DD 23:59:59')
          : ''
      });
    },

    createCostPrice() {
      this.$router.push({
        name: 'cost-prices-unit-prices-create'
      });
    },

    async loadFilterOptions() {
      try {
        const [
          providersResponse,
          packagingTypesResponse,
          transportDirectionsResponse,
          transportTypesResponse
        ] = await Promise.all([
          useService.getAllProviders({ paginated: false }),
          useService.constantService.getProviderRegionPricePackageType(),
          useService.constantService.getTransportDirection(),
          useService.constantService.getTransportType()
        ]);

        this.serviceProviderOptions = providersResponse.data.map(item => ({
          value: item.id,
          label: item.name
        }));

        this.packagingTypeOptions = packagingTypesResponse.data.map(item => ({
          value: item.value,
          label: item.info
        }));

        this.tradeTypeOptions = transportTypesResponse.data.map(item => ({
          value: item.value,
          label: item.info
        }));

        this.tradeDirectionOptions = transportDirectionsResponse.data.map(item => ({
          value: item.value,
          label: item.info
        }));
      } catch (error) {
        this.showErrorMessage(error);
      }
    }
  }
};
</script>
